/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getHealthWelfareKpi } from '../fn/kpi/get-health-welfare-kpi';
import { GetHealthWelfareKpi$Params } from '../fn/kpi/get-health-welfare-kpi';
import { KpiDto } from '../models/kpi-dto';
import { runCron } from '../fn/kpi/run-cron';
import { RunCron$Params } from '../fn/kpi/run-cron';
import { sendHealthWelfareKpi } from '../fn/kpi/send-health-welfare-kpi';
import { SendHealthWelfareKpi$Params } from '../fn/kpi/send-health-welfare-kpi';

@Injectable({ providedIn: 'root' })
export class KpiService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `runCron()` */
  static readonly RunCronPath = '/api/kpi/cron';

  /**
   * Run Cron.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `runCron()` instead.
   *
   * This method doesn't expect any request body.
   */
  runCron$Response(params?: RunCron$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return runCron(this.http, this.rootUrl, params, context);
  }

  /**
   * Run Cron.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `runCron$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  runCron(params?: RunCron$Params, context?: HttpContext): Observable<void> {
    return this.runCron$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getHealthWelfareKpi()` */
  static readonly GetHealthWelfareKpiPath = '/api/kpi/crop/{cropId}';

  /**
   * Get Health Welfare Kpi.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHealthWelfareKpi()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHealthWelfareKpi$Response(params: GetHealthWelfareKpi$Params, context?: HttpContext): Observable<StrictHttpResponse<KpiDto>> {
    return getHealthWelfareKpi(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Health Welfare Kpi.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHealthWelfareKpi$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHealthWelfareKpi(params: GetHealthWelfareKpi$Params, context?: HttpContext): Observable<KpiDto> {
    return this.getHealthWelfareKpi$Response(params, context).pipe(
      map((r: StrictHttpResponse<KpiDto>): KpiDto => r.body)
    );
  }

  /** Path part for operation `sendHealthWelfareKpi()` */
  static readonly SendHealthWelfareKpiPath = '/api/kpi/crop/{cropId}/send';

  /**
   * Send Health Welfare Kpi.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendHealthWelfareKpi()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendHealthWelfareKpi$Response(params: SendHealthWelfareKpi$Params, context?: HttpContext): Observable<StrictHttpResponse<KpiDto>> {
    return sendHealthWelfareKpi(this.http, this.rootUrl, params, context);
  }

  /**
   * Send Health Welfare Kpi.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendHealthWelfareKpi$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendHealthWelfareKpi(params: SendHealthWelfareKpi$Params, context?: HttpContext): Observable<KpiDto> {
    return this.sendHealthWelfareKpi$Response(params, context).pipe(
      map((r: StrictHttpResponse<KpiDto>): KpiDto => r.body)
    );
  }

}
